/** Navigation and chrome icons: views, the menu, panels and dismissal. */

import type { Component } from 'solid-js';
import { Svg } from './Svg.tsx';

export const TopView: Component = () => (
  <Svg>
    <circle cx="12" cy="12" r="8.2" />
    <circle cx="12" cy="12" r="2.1" class="fill" />
  </Svg>
);

export const AngleView: Component = () => (
  <Svg>
    <ellipse cx="12" cy="13" rx="8.6" ry="4.6" />
    <circle cx="12" cy="13" r="1.5" class="fill" />
  </Svg>
);

export const FrontView: Component = () => (
  <Svg>
    <rect x="3.4" y="9" width="17.2" height="7.4" rx="2.2" />
    <path d="M7.6 12.7h8.8" />
  </Svg>
);

/** The tonearm close-up: a pivot, an arm, and the record it reaches over. */
export const ArmView: Component = () => (
  <Svg>
    <circle cx="9" cy="14.5" r="5.2" />
    <circle cx="18.4" cy="5.6" r="1.8" />
    <path d="M17.2 6.9 12.6 11.7" />
  </Svg>
);

/** An arrow wound back on itself: the view returning to where it started. */
export const ResetView: Component = () => (
  <Svg>
    <path d="M5.2 12.4a6.9 6.9 0 1 0 1.6-4.4" />
    <path d="M4.6 4.6v4.2h4.2" />
  </Svg>
);

export const Gear: Component = () => (
  <Svg>
    <path d="M18.78 10.26 21.09 10.56 21.09 13.44 18.78 13.74 18.03 15.56 19.44 17.41 17.41 19.44 15.56 18.03 13.74 18.78 13.44 21.09 10.56 21.09 10.26 18.78 8.44 18.03 6.59 19.44 4.56 17.41 5.97 15.56 5.22 13.74 2.91 13.44 2.91 10.56 5.22 10.26 5.97 8.44 4.56 6.59 6.59 4.56 8.44 5.97 10.26 5.22 10.56 2.91 13.44 2.91 13.74 5.22 15.56 5.97 17.41 4.56 19.44 6.59 18.03 8.44Z" />
    <circle cx="12" cy="12" r="3" />
  </Svg>
);

export const Fullscreen: Component = () => (
  <Svg>
    <path d="M4.5 9.5v-5h5M14.5 4.5h5v5M19.5 14.5v5h-5M9.5 19.5h-5v-5" />
  </Svg>
);

export const FullscreenExit: Component = () => (
  <Svg>
    <path d="M9.5 4.5v5h-5M14.5 9.5v-5h5M19.5 14.5h-5v5M4.5 14.5h5v5" />
  </Svg>
);

export const Help: Component = () => (
  <Svg>
    <path d="M9.3 9.2a2.8 2.8 0 1 1 3.6 3.2c-.8.3-1.1 1-1.1 1.8v.4" />
    <circle cx="11.8" cy="18" r="1.1" class="fill" />
  </Svg>
);

export const Library: Component = () => (
  <Svg>
    <path d="M5 5.2v13.6M9.2 4.6v14.8M13.6 5.6l4.6 13.4" />
  </Svg>
);

export const Search: Component = () => (
  <Svg>
    <circle cx="11" cy="11" r="6.2" />
    <path d="M15.6 15.6 20 20" />
  </Svg>
);

export const QueueList: Component = () => (
  <Svg>
    <path d="M4 7h11M4 12h11M4 17h7" />
    <path d="M18.5 9.6v7.6" />
    <circle cx="16.6" cy="17.4" r="1.8" class="fill" />
  </Svg>
);

export const Close: Component = () => (
  <Svg>
    <path d="m7 7 10 10M17 7 7 17" />
  </Svg>
);

export const Back: Component = () => (
  <Svg>
    <path d="m14 6-6 6 6 6" />
  </Svg>
);

export const ChevronRight: Component = () => (
  <Svg>
    <path d="m10 6 6 6-6 6" />
  </Svg>
);

export const ChevronDown: Component = () => (
  <Svg>
    <path d="m7 10 5 5 5-5" />
  </Svg>
);

export const Check: Component = () => (
  <Svg>
    <path d="m5.5 12.5 4 4 9-9" />
  </Svg>
);
